// extracted by mini-css-extract-plugin
export default {"brandPromo":"VE-z","carousel":"WE-z"};